import styles from './StatsBar.module.scss';
import { useSelector } from 'react-redux';
import { selectScenarioThreeStats } from 'selectors/selectors';
import {
    checkNullReturnZero,
    formatNumber2DPStringIfNotZeroOrHundred,
    numberFormat
} from 'utils/common';

const ScenarioThreeStats = () => {
    const scenarioThreeStats = useSelector(selectScenarioThreeStats);
    const { totalEoTrades, percentEoTrades, totalOutliers, percentOutliers } = {
        ...scenarioThreeStats
    };
    return (
        <>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(numberFormat(totalEoTrades, true))}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentEoTrades
                        )}
                    </div>
                </div>
                <div className={styles.description}>Total EO Trades</div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S3 Outliers</div>
            </div>
        </>
    );
};

export default ScenarioThreeStats;
